import { LoginRes } from 'src/modules/dashboard/dto/login/login.res';

export const ADMIN_ROLE = 'admin' as const;
export const AREA_ADMIN_ROLE = 'area_admin' as const;

export function isAdminAccount(user?: Pick<LoginRes, 'role'> | null) {
  return user?.role === ADMIN_ROLE || user?.role === AREA_ADMIN_ROLE;
}

export function isFullAdminAccount(user?: Pick<LoginRes, 'role'> | null) {
  return user?.role === ADMIN_ROLE;
}
